// stahlia-frontend/src/lib/rack-builder.ts
// Logik des Regal-Baukastens (PlacesPage). SPIEGEL des Barcode-Formats aus
// src/modules/warehouse/codes.ts (buildPlaceBarcode, MAX_GENERATED_PLACES,
// zoneForLevel) und der Limits aus placeGenerateSchema (types.ts) —
// Aenderungen dort IMMER hier nachziehen.

export const MAX_GENERATED_PLACES = 2000
export const LIMITS = { fields: 99, slots: 20, levels: 15 }
// Spiegel von placeGenerateSchema row_code max(10) (src/modules/warehouse/types.ts).
export const MAX_ROW_CODE_LEN = 10

const ROW_RE = /^([A-Za-z]+)(\d{1,3})$/

/** "r1" -> "R01": Generator-Eingabe MUSS zweistellig sein, sonst entstehen
 *  Codes, die nicht zu den physischen Regal-Etiketten passen
 *  (Plans/BERICHT_PALETTENREGALE_LAGER2_2026-07-10.md §1). */
export function normalizeRowCode(input: string): string | null {
  const m = ROW_RE.exec(input.trim().toUpperCase())
  if (!m) return null
  const num = m[2]!
  const result = `${m[1]}${num.length < 2 ? num.padStart(2, '0') : num}`
  if (result.length > MAX_ROW_CODE_LEN) return null
  return result
}

export function buildBarcode(rowCode: string, field: number, slot: number, level: number): string {
  return `${rowCode}+F${String(field).padStart(2, '0')}+P${slot}+EB${level}`
}

// User-Regel 2026-07-10: NUR EB1 ist zu Fuss pickbar — ab EB2 Stapler.
export function zoneForLevel(level: number): 'fuss' | 'stapler' {
  return level <= 1 ? 'fuss' : 'stapler'
}

export function clampDim(v: number, max: number): number {
  if (!Number.isFinite(v)) return 1
  return Math.min(max, Math.max(1, Math.floor(v)))
}

export interface RackPreview {
  count: number
  overLimit: boolean
  first: string
  last: string
}

export function rackPreview(
  rowCode: string, fields: number, slots: number, levels: number,
): RackPreview | null {
  if (fields < 1 || slots < 1 || levels < 1) return null
  const count = fields * slots * levels
  return {
    count,
    overLimit: count > MAX_GENERATED_PLACES,
    first: buildBarcode(rowCode, 1, 1, 1),
    last: buildBarcode(rowCode, fields, slots, levels),
  }
}
